import { Switcher } from '@leprecoins/effector';
import { createForm, Form, FormParams } from '@leprecoins/effector-forms';
import { createEvent, createStore, EventCallable, sample, StoreWritable } from 'effector';
import { createModalSwitcher } from './modal';

export type ModalFormModel<
	TModalData,
	TFormValues extends Record<string, unknown> = Record<string, never>,
> = {
	form: Form<TFormValues>;
	switcher: Switcher;
	$modalData: StoreWritable<TModalData | null>;
	modalButtonClicked: EventCallable<TModalData>;
	modalClosed: EventCallable<void>;
};

export type ModalFormParams<TFormValues extends Record<string, unknown> = Record<string, never>> =
	FormParams<TFormValues>;

export const createModalFormModel = <
	TModalData,
	TFormValues extends Record<string, unknown> = Record<string, never>,
>(
	params: ModalFormParams<TFormValues>,
): ModalFormModel<TModalData, TFormValues> => {
	const switcher = createModalSwitcher();

	const form = createForm(params);

	const $modalData = createStore<TModalData | null>(null);

	const modalButtonClicked = createEvent<TModalData>();

	const modalClosed = createEvent();

	sample({
		clock: modalButtonClicked,
		target: [$modalData, switcher.enable],
	});

	sample({
		clock: modalClosed,
		target: [$modalData.reinit, switcher.disable, form.reset],
	});

	return {
		form,
		switcher,
		$modalData,
		modalButtonClicked,
		modalClosed,
	};
};
